import React, { Suspense } from 'react';

import { getDataFetcherForSuspense, type SuspenseableDataFetcher } from './dataFetcherForSuspense';

function SuspenseWithDataFetcherReader({
	dataFetcher,
	children,
}: {
	dataFetcher: SuspenseableDataFetcher | null;
	children: React.ReactNode;
}) {
	// eslint-disable-next-line check-react-ssr-usage/no-react-ssr
	if (process.env.REACT_SSR) {
		dataFetcher?.read();
	}
	return <>{children}</>;
}

export function SuspenseWithDataFetcher({
	dataFetcherName,
	fallback = null,
	children,
}: {
	dataFetcherName: string;
	fallback?: React.ReactNode;
	children: React.ReactNode;
}) {
	if (window.__SSR_REACT_STREAMING__) {
		const dataFetcher = getDataFetcherForSuspense(dataFetcherName);
		return (
			<Suspense fallback={fallback}>
				<SuspenseWithDataFetcherReader dataFetcher={dataFetcher}>
					{children}
				</SuspenseWithDataFetcherReader>
			</Suspense>
		);
	} else {
		return <>{children}</>;
	}
}
